import { Injectable } from '@angular/core';
import { OverviewChartPeriods } from '../enums/overview-chart-periods.enum';
import { OptionSwitchItem } from '../components/option-switch/option-switch.component';
import { chartData } from '../models/dashboard.model';

@Injectable({ providedIn: 'root' })
export class RevenueChartBarsService {
  readonly periodOptions: OptionSwitchItem[] = [
    // { label: 'Today', value: OverviewChartPeriods.today },
    { label: '7 Days', value: OverviewChartPeriods.week },
    { label: '30 Days', value: OverviewChartPeriods.month },
    { label: '12 Months', value: OverviewChartPeriods.year },
  ];

  getChartConfig(labels: string[], data: number[]): any {
    return {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          data,
          backgroundColor: '#8b5cf6',
          borderRadius: 6,
          barThickness: 32
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // Changed: Set to false to allow height control via CSS
        plugins: {
          legend: { display: false },
          tooltip: {
            displayColors: false,
            callbacks: {
              title: () => {
                return '';
              },
              label: (tooltipItem: any) => {
                const value = tooltipItem.raw;
                return `$${value}`;
              }
            }
          }
        },
        scales: {
          x: { grid: { display: false } },
          y: {
            beginAtZero: true
            // Changed: Removed 'ticks: { stepSize: 20 }' to avoid too many labels.
            // Chart.js will now automatically scale ticks based on data.
          }
        }
      }
    }
  }

  getChartData(period: OverviewChartPeriods, apiData: chartData): { labels: string[]; data: number[] } {
    switch (period) {
      case OverviewChartPeriods.year:
        return {
          labels: apiData?.['12m']?.['labels'] ?? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          data: apiData?.['12m']?.['values'] ?? []
        };
      case OverviewChartPeriods.month:
        return {
          labels: apiData?.['30d']?.['labels'] ?? Array.from({ length: 30 }, (_, i) => `Day ${i + 1}`),
          data: apiData?.['30d']?.['values'] ?? []
        };
      case OverviewChartPeriods.week:
        return {
          labels: apiData?.['7d']?.['labels'] ?? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          data: apiData?.['7d']?.['values'] ?? []
        };
      case OverviewChartPeriods.today:
        return {
          labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'],
          data: [40, 70, 60, 90, 50, 30, 80]
        };
      default:
        return { labels: [], data: [] };
    }
  }
}
